export default __webpack_public_path__ + "78545ef02a52597828a8c588b9b180c3.png";